import DashboardLayoutMod from "@/views/Layout/DashboardLayout";
import module from "@/enums/module";
import action from "@/enums/action";
import SolicitudesHistoricasList
  from "@/components/Ciudadano/SolicitudesHistoricas/SolicitudesHistoricasList/SolicitudesHistoricasList";
import SolicitudesHistoricasView
  from "@/components/Ciudadano/SolicitudesHistoricas/SolicitudesHistoricasView/SolicitudesHistoricasView";
import RegistroHistorico from "@/components/Ciudadano/RegistroHistorico/RegistroHistorico";

const registroHistoricoMenu = {
  path: '/registro-historico',
  component: DashboardLayoutMod,
  redirect: '/lista',
  meta: {module: module.CIUDADANOS_RESUMEN_TRAMITES, action: [action.CONSULTAR], requiresAuth: true},
  children: [
    {
      path: 'lista',
      name: 'solicitudes-historicas',
      component: SolicitudesHistoricasList,
      meta: {
        module: module.CIUDADANOS_SOLICITUDES_HISTORICAS,
        action: [action.CONSULTAR],
        requiresAuth: true,
        title: 'Solicitudes Históricas'
      },
    },
    {
      path: 'solicitud',
      name: 'registro-historico-solicitud',
      component: RegistroHistorico,
      meta: {
        module: module.CIUDADANOS_REGISTRO_HISTORICO,
        action: [action.CREAR],
        requiresAuth: true,
        title: 'Registro Histórico'
      },
    },
    {
      path: 'lista/solicitud/:id',
      name: 'solicitud-historica-view-id',
      component: SolicitudesHistoricasView,
      meta: {
        module: module.CIUDADANOS_SOLICITUDES_HISTORICAS,
        action: [action.CONSULTAR],
        requiresAuth: true,
        title: 'Ver Solicitud Histórica'
      },
    },
  ]
};

export default registroHistoricoMenu
